/**
 * ClientHeroV2 — Hero du cockpit client (mobile-first).
 * ─────────────────────────────────────────────────────
 * Miroir de DossierHeroV2 côté agence.
 * Répond à : « Voici VOTRE véhicule, voici où on en est. »
 *
 * Layout :
 *   • Photo pleine largeur en haut (ratio 4/3)
 *   • Marque véhicule (H1)
 *   • Client · BC · Agence (ligne meta)
 *   • Progression % + barre 13 segments Tesla (read-only interactif)
 */
import { WorkflowProgress, MicroLabel } from "@/components/wyvio-ui";

const ClientHeroV2 = ({ vehicle, agency }) => {
  return (
    <section
      data-testid="client-hero-v2"
      className="rounded-3xl border border-[#EEF2F5] dark:border-[#262626] bg-white dark:bg-[#111111] overflow-hidden"
    >
      {/* Photo pleine largeur */}
      <div className="relative aspect-[4/3] bg-[#F3F4F6] dark:bg-[#0A0A0A]">
        {vehicle.image ? (
          <img
            src={vehicle.image}
            alt={vehicle.name}
            className="absolute inset-0 h-full w-full object-cover"
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center text-[#D1D5DB] dark:text-[#3A3A3A]">
            <svg viewBox="0 0 64 48" className="h-24 w-24" fill="none" stroke="currentColor" strokeWidth="1.2">
              <path d="M6 33 L10 22 C12 18 15 16 20 16 L44 16 C49 16 52 18 54 22 L58 33" />
              <path d="M4 33 H60 V38 C60 39 59 40 58 40 H52 C51 40 50 39 50 38 V37 H14 V38 C14 39 13 40 12 40 H6 C5 40 4 39 4 38 Z" />
              <circle cx="17" cy="37" r="3" />
              <circle cx="47" cy="37" r="3" />
            </svg>
          </div>
        )}
      </div>

      <div className="p-6 sm:p-7">
        <p className="text-[11px] font-medium text-[#6B7280] dark:text-[#A3A3A3]">
          Votre véhicule
        </p>
        <h1
          data-testid="client-hero-title"
          className="mt-1.5 text-[26px] sm:text-[32px] leading-[1.05] font-semibold tracking-[-0.03em] text-[#0A0A0A] dark:text-white"
        >
          {vehicle.name}
        </h1>

        <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1 text-[12.5px] text-[#6B7280] dark:text-[#A3A3A3]">
          <span
            data-testid="client-hero-order"
            className="tabular-nums font-medium text-[#0A0A0A] dark:text-white"
          >
            {vehicle.orderNumber}
          </span>
          {agency?.name && (
            <>
              <span className="text-[#D1D5DB] dark:text-[#3A3A3A]">·</span>
              <span>{agency.name}</span>
            </>
          )}
        </div>

        <div className="mt-6">
          <div className="flex items-baseline justify-between">
            <MicroLabel>Progression</MicroLabel>
            <span
              data-testid="client-hero-progress"
              className="text-[26px] font-semibold text-[#0A0A0A] dark:text-white tabular-nums leading-none"
            >
              {vehicle.progress}
              <span className="text-[13px] text-[#9CA3AF] dark:text-[#525252] ml-0.5">%</span>
            </span>
          </div>
          <div className="mt-3" data-testid="client-hero-progress-bar">
            <WorkflowProgress steps={vehicle.steps || []} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientHeroV2;
